var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wrk-13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229.379,
    height: 38.284,
    viewBox: "0 0 229.379 38.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    width: 229.379,
    height: 38.073,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    width: 17.515,
    height: 10.891,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201",
    "data-name": "Rectangle 1201",
    width: 6.626,
    height: 31.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1202",
    "data-name": "Rectangle 1202",
    width: 30.321,
    height: 31.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1203",
    "data-name": "Rectangle 1203",
    width: 18.865,
    height: 31.279,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1204",
    "data-name": "Rectangle 1204",
    width: 13.078,
    height: 12.893,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1205",
    "data-name": "Rectangle 1205",
    width: 28.092,
    height: 31.419,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1206",
    "data-name": "Rectangle 1206",
    width: 24.827,
    height: 31.42,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1207",
    "data-name": "Rectangle 1207",
    width: 31.088,
    height: 31.086,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 25.278,
    height: 31.419,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1209",
    "data-name": "Rectangle 1209",
    width: 27.875,
    height: 31.195,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1454",
    "data-name": "Rectangle 1454",
    width: 229.378,
    height: 38.073,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3002",
    "data-name": "Group 3002",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3001",
    "data-name": "Group 3001",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3000",
    "data-name": "Group 3000",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2999",
    "data-name": "Group 2999",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2971",
    "data-name": "Group 2971",
    transform: "translate(82.702)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2970",
    "data-name": "Group 2970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2969",
    "data-name": "Group 2969",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10762",
    "data-name": "Path 10762",
    d: "M62.1,2.095l8.761,8.8L79.611,2.1a19.346,19.346,0,0,0-17.515,0",
    transform: "translate(-62.096 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974",
    transform: "translate(0 6.736)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2972",
    "data-name": "Group 2972",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1200",
    "data-name": "Rectangle 1200",
    width: 6.626,
    height: 31.254,
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2977",
    "data-name": "Group 2977",
    transform: "translate(11.332 6.697)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2976",
    "data-name": "Group 2976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2975",
    "data-name": "Group 2975",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10763",
    "data-name": "Path 10763",
    d: "M24.162,29.688a9.074,9.074,0,0,1-8.845-7.152,9.766,9.766,0,0,1-.181-1.854,8.85,8.85,0,0,1,.181-1.793,9.04,9.04,0,0,1,8.845-7.233,8.946,8.946,0,0,1,7.192,3.587h7.474A15.641,15.641,0,0,0,8.669,18.466a16.3,16.3,0,0,0-.161,2.216,17.194,17.194,0,0,0,.161,2.276,15.672,15.672,0,0,0,24.78,10.315A15.4,15.4,0,0,0,38.829,26.1H31.314a8.983,8.983,0,0,1-7.152,3.587",
    transform: "translate(-8.509 -5.029)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2980",
    "data-name": "Group 2980",
    transform: "translate(53.778 6.711)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2979",
    "data-name": "Group 2979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2978",
    "data-name": "Group 2978",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10764",
    "data-name": "Path 10764",
    d: "M51.036,5.039,40.379,20.679v15.64H47V22.847L59.243,5.039Z",
    transform: "translate(-40.379 -5.039)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2983",
    "data-name": "Group 2983",
    transform: "translate(41.53 6.708)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2982",
    "data-name": "Group 2982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2981",
    "data-name": "Group 2981",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10765",
    "data-name": "Path 10765",
    d: "M44.26,12.175,40.036,17.93,31.182,5.037h8.209Z",
    transform: "translate(-31.182 -5.037)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986",
    transform: "translate(77.413 6.654)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10766",
    "data-name": "Path 10766",
    d: "M58.125,19.251l6.626,6.613V36.415H58.125ZM86.217,5V36.415H79.593V19.545L76.078,23.06l-1.354,1.353-.364.364-1.212,1.211-.878.876-4.46-4.458-3.059-3.059-6.626-6.626V5h1.649l6.3,6.3,6.193,6.2L84.77,5Z",
    transform: "translate(-58.125 -4.996)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2989",
    "data-name": "Group 2989",
    transform: "translate(142.858 6.654)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10767",
    "data-name": "Path 10767",
    d: "M132.091,29.79v6.626H107.264V5h6.626V29.79Z",
    transform: "translate(-107.264 -4.996)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2992",
    "data-name": "Group 2992",
    transform: "translate(168.262 6.987)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2991",
    "data-name": "Group 2991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2990",
    "data-name": "Group 2990",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10768",
    "data-name": "Path 10768",
    d: "M141.883,11.733a9.056,9.056,0,1,0,9.054,9.055,9.067,9.067,0,0,0-9.054-9.055m15.543,9.055A15.544,15.544,0,1,1,141.883,5.247a15.56,15.56,0,0,1,15.543,15.541",
    transform: "translate(-126.338 -5.246)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2995",
    "data-name": "Group 2995",
    transform: "translate(204.1 6.654)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2994",
    "data-name": "Group 2994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2993",
    "data-name": "Group 2993",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10769",
    "data-name": "Path 10769",
    d: "M153.247,19.257l6.625,6.625V36.374h-6.625ZM178.525,5.166V36.415h-1.586l-4.679-4.677-7.851-7.853-4.538-4.536-6.625-6.623V5h1.645L171.9,22V5.166Z",
    transform: "translate(-153.247 -4.996)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998",
    transform: "translate(110.277 6.878)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2997",
    "data-name": "Group 2997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2996",
    "data-name": "Group 2996",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10770",
    "data-name": "Path 10770",
    d: "M110.676,11.79V5.164H82.8l0,1.244V26.027h0v3.707l0,1.243V36.36h27.875V29.734H89.429v-6.7H107.9V16.409H89.429V11.79Z",
    transform: "translate(-82.8 -5.164)",
    fill: "#040504"
  }))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(0 0.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3448-2",
    "data-name": "Group 3448",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11130",
    "data-name": "Path 11130",
    d: "M62.1,2.095l8.761,8.8L79.611,2.1a19.346,19.346,0,0,0-17.515,0",
    transform: "translate(20.606 0)",
    fill: "#cb0036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    "data-name": "Rectangle 1453",
    width: 6.626,
    height: 31.254,
    transform: "translate(0 6.736)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11131",
    "data-name": "Path 11131",
    d: "M24.162,29.688a9.074,9.074,0,0,1-8.845-7.152,9.766,9.766,0,0,1-.181-1.854,8.85,8.85,0,0,1,.181-1.793,9.04,9.04,0,0,1,8.845-7.233,8.946,8.946,0,0,1,7.192,3.587h7.474A15.641,15.641,0,0,0,8.669,18.466a16.3,16.3,0,0,0-.161,2.216,17.194,17.194,0,0,0,.161,2.276,15.672,15.672,0,0,0,24.78,10.315A15.4,15.4,0,0,0,38.829,26.1H31.314a8.983,8.983,0,0,1-7.152,3.587",
    transform: "translate(2.823 1.668)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11132",
    "data-name": "Path 11132",
    d: "M51.036,5.039,40.379,20.679v15.64H47V22.847L59.243,5.039Z",
    transform: "translate(13.399 1.672)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11133",
    "data-name": "Path 11133",
    d: "M44.26,12.175,40.036,17.93,31.182,5.037h8.209Z",
    transform: "translate(10.348 1.671)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11134",
    "data-name": "Path 11134",
    d: "M58.125,19.251l6.626,6.613V36.415H58.125ZM86.217,5V36.415H79.593V19.545L76.078,23.06l-1.354,1.353-.364.364-1.212,1.211-.878.876-4.46-4.458-3.059-3.059-6.626-6.626V5h1.649l6.3,6.3,6.193,6.2L84.77,5Z",
    transform: "translate(19.288 1.658)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11135",
    "data-name": "Path 11135",
    d: "M132.091,29.79v6.626H107.264V5h6.626V29.79Z",
    transform: "translate(35.594 1.658)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11136",
    "data-name": "Path 11136",
    d: "M141.883,11.733a9.056,9.056,0,1,0,9.054,9.055,9.067,9.067,0,0,0-9.054-9.055m15.543,9.055A15.544,15.544,0,1,1,141.883,5.247a15.56,15.56,0,0,1,15.543,15.541",
    transform: "translate(41.924 1.741)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11137",
    "data-name": "Path 11137",
    d: "M153.247,19.257l6.625,6.625V36.374h-6.625ZM178.525,5.166V36.415h-1.586l-4.679-4.677-7.851-7.853-4.538-4.536-6.625-6.623V5h1.645L171.9,22V5.166Z",
    transform: "translate(50.853 1.658)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11138",
    "data-name": "Path 11138",
    d: "M110.676,11.79V5.164H82.8l0,1.244V26.027h0v3.707l0,1.243V36.36h27.875V29.734H89.429v-6.7H107.9V16.409H89.429V11.79Z",
    transform: "translate(27.476 1.714)",
    fill: "#161615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk13);
export default __webpack_public_path__ + "static/media/wrk-13.f59a6f311d3df9d9fcbd2c9dac4be849.svg";
export { ForwardRef as ReactComponent };